import { render, staticRenderFns } from "./journalFilters.vue?vue&type=template&id=412312b6&scoped=true&lang=pug"
import script from "./journalFilters.vue?vue&type=script&lang=js"
export * from "./journalFilters.vue?vue&type=script&lang=js"
import style0 from "./journalFilters.vue?vue&type=style&index=0&id=412312b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412312b6",
  null
  
)

export default component.exports